import { render, staticRenderFns } from "./idnex.vue?vue&type=template&id=07a86dd1&scoped=true&"
import script from "./idnex.vue?vue&type=script&lang=ts&"
export * from "./idnex.vue?vue&type=script&lang=ts&"
import style0 from "./idnex.vue?vue&type=style&index=0&id=07a86dd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a86dd1",
  null
  
)

export default component.exports